import { Box, Chip, Divider, Tooltip, Typography } from "@mui/material";
import { FREE_AI_LIMIT, FREE_EXPORT_LIMIT } from "src/content/pages/cv-builder/ai";
import { ToolPlan, useToolPlan } from "src/utils/toolPlan";

const PLAN_SUMMARY: Record<ToolPlan, string> = {
	free: `CV Builder: ${FREE_AI_LIMIT}x analisis AI, ${FREE_EXPORT_LIMIT}x unduh`,
	pro: "CV Builder: analisis AI & unduh tanpa batas",
};

const PlanChip = ({ plan }: { plan: ToolPlan }) => {
	const pro = plan === "pro";
	return (
		<Chip
			size="small"
			label={pro ? "Pro" : "Free"}
			variant={pro ? "filled" : "outlined"}
			data-testid="plan-chip"
			sx={(theme) => ({
				height: 20,
				flexShrink: 0,
				fontSize: theme.typography.pxToRem(11),
				fontWeight: 700,
				letterSpacing: "0.02em",
				"& .MuiChip-label": { px: 0.75 },
				...(pro
					? { backgroundColor: theme.colors.primary.main, color: theme.palette.primary.contrastText }
					: { borderColor: theme.colors.alpha.black[30], color: theme.colors.alpha.black[70] }),
			})}
		/>
	);
};

/** Chip Free/Pro di sebelah nama (sidebar, akun, dll.). */
export const PlanBadge = () => {
	const plan = useToolPlan();
	if (!plan) return null;
	return (
		<Tooltip title={PLAN_SUMMARY[plan]} arrow placement="top">
			<span style={{ display: "inline-flex", flexShrink: 0 }}>
				<PlanChip plan={plan} />
			</span>
		</Tooltip>
	);
};

/** Ringkasan paket di dalam popover profil. */
export const PlanInfo = () => {
	const plan = useToolPlan();
	if (!plan) return null;
	return (
		<>
			<Box px={2} py={1} display="flex" alignItems="center" gap={1} data-testid="plan-info">
				<PlanChip plan={plan} />
				<Typography variant="caption" color="text.secondary" lineHeight={1.4}>
					{PLAN_SUMMARY[plan]}
				</Typography>
			</Box>
			<Divider />
		</>
	);
};
